<div class="fontsize-color-display">
    <p class="is-taller"><a [routerLink]="['/login']" class="bofa--button reverse mobile-flex">&larr; Log In</a></p>
    <a href="/bsiAF/api/downloadAAGenLetter?tokenId={{ token }}" target="_blank" rel="noopener noreferrer" class="af-anchor"
    aria-label="view AA letter">View AA Letter</a>
</div>